/* 
 * ---------------------------------------- *
 * Name:    Primary JavaScripts             *
 * Project: City and Guilds                 *
 * Type:    JavaScript                      *
 * Version: Not Versioned                   *
 * Author:  Codehouse Group LTD             *
 * ---------------------------------------- *
 */

if (!window.console) {
    window.console = { log : function () {} };
}

var blockGeoSearch = false;
var geoCodeSuccess = false;
var isIE10 = navigator.appVersion.indexOf("MSIE 10") != -1; // for amd 

(function ($) {
    $(document).ready(function () {
        
        var isIe6 = $('html').hasClass('ie6'),
            oldie = $('html').hasClass('oldie'),
            isPreview = $('html').hasClass('preview-mode');

        $('html').addClass(isIE10 ? "ie" : ""); 

        $('.geo-search-button').click(function () {
            var button = $(this);
            button.addClass('clicked');
            var geoValue = $('#geo_data').val();

            if (!blockGeoSearch) {
                if ($(this).attr('href')) {
                    eval($(this).attr('href').replace(/javascript:/, ''));
                } else {
                    $("#searchCentre form").submit();
                }
            }
            return false;
        });
        var fill;
        $('.datepicker-input input').keyup(function () {
	        fill = $(this).val();
	    }).keydown(function (e) {
	        var b = $(this);
	        if (e.keyCode == 13) {
	           setTimeout(function () {
	                b.val(fill);
	           });
	        }
	    });
        
        /* Enter key pressed */
        $('.geocode-target').keydown(function (event) {
            // track enter key
            var keycode = (event.keyCode ? event.keyCode : (event.which ? event.which : event.charCode));
            if (keycode === 13) { //If enter key
                event.preventDefault();
                if ($(this).val() === '') {
                    return false;
                }
                // block the search here as otherwise a race condition is encountered and the click can redirect before it has geocoded
                blockGeoSearch = true;
                var button = $(this).parent().parent().find('.geo-search-button');
                button.focus();
                button.click();
            }
        });
        
        //Evenly space navigation items
        //$('#main-nav').evenNavigation();
        //$('#sub-nav').evenNavigation(1024);


        /* region list */
        $('#region-select').hover(function () {
            $('#region-list').toggleClass('visible');
        });

        /* Help bubbles */
        $('.help-text').hide(); //hide on load
        $('.help-icon').hover(function () {
            $('.help-text', $(this)).stop(true, true).toggle();
        });

        /* Sliders */
            var sliderHome = $('.slider-home'),
                sliderMedSmall = $('.slider-medium, .slider-small'),
                sliderTools = $('.slider-tools'),
                sliderRichMedia = $('.slider-richmedia'),
                sliderHomeOptions = { controls: false, mode: 'vertical', easing: 'easeOutQuint' },
                sliderToolsOptions = { infiniteLoop: false, controls: false, mode: 'fade' },
                sliderRichMediaOptions = { controls: false, mode: 'horizontal', easing: 'easeOutQuint' },
                defaultToolsDimensions = { start: '160px', finish: '170px', duration: 100 },
                sl6ToolsDimensions = { start: '190px', finish: '200px', duraction: 100 };

            if (isPreview) {
                sliderHomeOptions['easing'] = '';
                sliderRichMediaOptions['easing'] = '';
            }

            sliderHome.each(function() {
                checkInterval($(this), sliderHomeOptions);
                $(this).initSlider(sliderHomeOptions, false, false, isIe6);
            });
            
            sliderMedSmall.each(function() {
                var sliderThumbs = $('.slider-thumbs li', $(this)),
                    sliderOptions = {
                        hideControlOnEnd: true,
                        infiniteLoop: false,
                        onBeforeSlide: function(slideIndex) {
                            sliderThumbs.removeClass('active');
                            sliderThumbs.eq(slideIndex).addClass('active');
                        }
                    };

                checkInterval($(this), sliderOptions);
                $(this).initSlider(sliderOptions, false, false, false);
            });
            
            sliderTools.each(function() {
                if ($(this).parent('#right-wide-rail-list').length > 0) {
                    checkInterval($(this), sliderToolsOptions);
                    $(this).initSlider(sliderToolsOptions, 'sL6sliderTools', sl6ToolsDimensions, false);
                } else {
                    checkInterval($(this), sliderToolsOptions);
                    $(this).initSlider(sliderToolsOptions, 'sliderTools', defaultToolsDimensions, false);
                }
            });

            sliderRichMedia.each(function() {
                checkInterval($(this), sliderRichMediaOptions);
                $(this).initSlider(sliderRichMediaOptions, false, false, false);
            });

            $('.four-images', sliderMedSmall).each(function() {
                if ($(this).parents('.bx-wrapper').addClass('four-image-slider').find('.bx-next').css('display') == 'block') {
                    $(this).removeClass('four-images').addClass('four-images-slide');
                }
            });

            if($('html').hasClass('ie7')) {
                $('#sl7').height($('.slider-medium').outerHeight(true) + $('#sl7 > h1').outerHeight(true) + $('#content').outerHeight(true));                
            }

        /* faux accordions */
        $('.toggle-panel dd').hide();
        $('.toggle-panel dt').click(function () {
            $(this).toggleClass('close').next('dd').toggle();
        });
        $('.toggle-panel:last-child').addClass('toggle-panel-last-child');
        $('.ajax-toggle-panel:last-child').addClass('ajax-toggle-panel-last-child');

        /* form hooks */
        $('input[type=text]').addClass('input-text');
        $('select').addClass('input-select');

        //add watermark to input text boxes [based on title text]
        $('.input-text').each(function () {
            waterMarking($(this));
        });

        /*  ==============================
            Header Search Client Functions
            ============================== */
        var searchWidth = 0;
        $('#search-tab-nav li').each(function () {
            searchWidth += $(this).width(true);
            return searchWidth;

        });
        $('#header-search').css('width', searchWidth);
        $(document).on('ready', function () {
            $('#header-search > #searchAll').css('display', 'block');
        });

        /* <li> Click  show/hide sections */
        $('#search-tab-nav li').click(function () {
            $('#search-tab-nav li').removeClass('active');
            $('.mobile-search-tab').removeClass('active');
            $(this).addClass('active');

            var index = $(this).index();

            $('.mobile-search-tab[data-index="' + index + '"]').addClass('active');
            $('.header-search__panels > div').hide();
            $('.header-search__panels > div').eq(index).css('display', 'block'); 
            return false;
        });

        $('.mobile-search-tab').click(function () {
            $('.mobile-search-tab').removeClass('active');
            $('#search-tab-nav li').removeClass('active');
            $(this).addClass('active');

            var index = $(this).data('index');

            $('#search-tab-nav li').eq(index).addClass('active');
            $('.header-search__panels > div').hide();
            $('.header-search__panels > div').eq(index).css('display', 'block'); 
            return false;
        });
        
        /* On blur, getGeoCode information */
        //$('input.geocode-target').blur(function () {
        //    getGeoCode($(this).val(), $(this).siblings('input.geocode-container'));
        //});

        function throttle(f, delay) {
            var timer = null;
            return function () {
                var context = this, args = arguments;
                clearTimeout(timer);
                timer = window.setTimeout(function () {
                    f.apply(context, args);
                },
                    delay || 500);
            };
        }
        $('input.geocode-target').keyup(throttle(function () {
            getGeoCode($(this).val(), $(this).siblings('input.geocode-container'));
        }));

        /* --------------------------------------
           Web forms for marketers
        ----------------------------------------- */
      
        // TODO: WFFM CHECK 

        $('.scfValidatorRequired').css('position', 'absolute');
        var innerControl = $('.scfValidatorRequired').hasClass('inner.1'); //establish which control types is being used, inner/ or not

        $('#root-content').on('click', '.scfForm input[type=submit]', function () {
            if ($('.scfValidatorRequired:visible')) {
                if(innerControl){ //if inner control is selected (therefore has class inner.1)
                   $('.scfValidatorRequired:visible').parent().parent().addClass('validation-error'); //seek parent parent
                   }
                else {//else only seek immediate parent
                   $('.scfValidatorRequired:visible').parent().addClass('validation-error'); 
                }
            }
        });
        
        var error,
            item;
        $('#root-content').on('blur', '.scfForm input', function () {
           if(innerControl){ //if inner control is selected (therefore has class inner.1)

                    error = $(this).parent().find('.scfValidatorRequired').css('display'), // find if there is an error at associated field
                    item = $(this).parent().find('.scfValidatorRequired'); // assign element to variable
                }
            else
            {
                    error = $(this).parent().parent().find('.scfValidatorRequired').css('display'), // find if there is an error at associated field
                    item = $(this).parent().parent().find('.scfValidatorRequired'); // assign element to variable
            }
            if(error != 'none') {
                if(innerControl) {
                    item.parent().parent().addClass('validation-error'); //seek parent parent
                }
                else {
                    item.parent().addClass('validation-error');
                }
            }
            else {
                if(innerControl) {
                    item.parent().parent().removeClass('validation-error'); //seek parent parent
                }
                else {
                    item.parent().removeClass('validation-error');
                }
            }
        });
        
        $('#root-content').on('change', '.scfForm select', function () {
           if(innerControl){ //if inner control is selected (therefore has class inner.1)

                    error = $(this).parent().find('.scfValidatorRequired').css('display'), // find if there is an error at associated field
                    item = $(this).parent().find('.scfValidatorRequired'); // assign element to variable
                }
            else
            {
                    error = $(this).parent().parent().find('.scfValidatorRequired').css('display'), // find if there is an error at associated field
                    item = $(this).parent().parent().find('.scfValidatorRequired'); // assign element to variable
            }
            if(error != 'none') {
                if(innerControl) {
                    item.parent().parent().addClass('validation-error'); //seek parent parent
                }
                else {
                    item.parent().addClass('validation-error');
                }
            }
            else {
                if(innerControl) {
                    item.parent().parent().removeClass('validation-error'); //seek parent parent
                }
                else {
                    item.parent().removeClass('validation-error');
                }
            }
        });      

        /* loading-mask resizer */
        var getHeight = $('#narrow-left-content').height();

        $('#narrow-left-content').click(function() {
            getHeight = $('#tab-content').height();
            getHeight = getHeight + 23;
            $('.apprenticeship #loading-mask').css('height',getHeight);
        });
                
        $('.search-widget a.button-link-red').click(function(e) {
            if(!geoCodeSuccess) {
                e.preventDefault();
                $('#geocode-validation').show();
            }            
        });
        // poll widget
        if (oldie) {
            $('.poll-widget ul li label').click(function() {
                var $label = $(this);
                $("#" + $label.attr("for")).click(); // needed because we are returning false
                if ($label.siblings('input').prop('checked')) {
                    $label.addClass('checked');
                } else {
                    $label.removeClass('checked');
                }
                return false; // prevent IE7 jumping to bottom of page
            });
        }
        
        if ($("#find-course").length) {
            if ($('#tab-nav li a').length > 0) {
                $('#tab-content .uk, #tab-content .international, #tab-content .apprenticeships').hide(); // ?

                switch ($('#tab-nav li a.active').parent().index()) {
                    case 0:
                        $('#tab-content .uk').show();
                        break;
                    case 1:
                        $('#tab-content .international').show();
                        break;
                    case 2:
                        $('#tab-content .apprenticeships').show();
                        break;
                }
            }

            // link action
            // $('#find-course #tab-content a:not(".course")').live('click', function (e) {

                // var courseLink = $(this);

                // var thisTab = courseLink.parents('#tab-content > div').attr('class');
                // var backLink = courseLink.hasClass('back-link');
                // var title = courseLink.text();
                // var link = courseLink.attr("href");
                // var $bread = $('#breadcrumb');

                // if (typeof (history) != 'undefined') {
                    // history.pushState({ id: $(this).attr('title') }, $(this).attr('title'), $(this).attr('href'));
                // }

                // $('#tab-content').addClass('loading');

                // $.ajax({
                    // url: '/WebServices/CourseService.svc/GetCourseData',
                    // data: { sitecorePath: $(this).attr('data-id'), tab: thisTab },
                    // type: "GET",
                    // dataType: "json",
                    // contentType: "application/json; charset=utf-8",
                    // success: function (data) {
                           // if (backLink) {
                            // $('#tab-content .' + thisTab).animate({ 'left': '+=368px' }, 200, function () {
                                // $(this).replaceWith(data.d);
                                // $('#tab-content .' + thisTab).css({ 'left': '-368px' }).animate({ 'left': '+=368px' }, 200);
                            // });
                        // }
                        // else {
                            // $('#tab-content .' + thisTab).animate({ 'left': '-=368px' }, 200, function () {
                                // $(this).replaceWith(data.d);
                                // $('#tab-content .' + thisTab).css({ 'left': '368px' }).animate({ 'left': '-=368px' }, 200);
                            // });
                        // }
                        // $('#tab-content').removeClass('loading');

                        // // update breadcrumb
                        // if (!backLink) { 
                            // $bread.append("<li><a href='" + link + "'>" + title + "</a><span class='sep'>></span></li>");
                            // $bread.children().removeClass("last").last().addClass("last");
                        // } else {
                            // $bread.children().last().remove();
                            // $bread.children().last().addClass("last");
                        // }
                    // },
                    // error: function () {
                        // $('#tab-content').removeClass('loading');
                    // }
                // });
                // e.preventDefault();
            // });
        }
    
        // twitter social widget
        $(".twitter-feed > .tweet-text").each(function() {
            $(this).html(usrRplc(lnkRplc($(this).text())));
        });
        
        if ($('.widget.twitter-widget').length) {
            setTimeout(function () {
                $('.widget.twitter-widget').find('.loading').fadeOut();
            }, 2000);
        }
        
        /* script includes
         * ---------------------------------------------------------- */
        
        // scroll bar
        if ($(".scrollable").length) {
            loadScript("scrollbar.js", function () {
                $(".scrollable").socialScroll();
            }, false); // bool for global extension 
        }

        if ($('.location-filter, .accordion-container, .tabbed-nav').length) {
            cQAccordion();
        }
        
    }); // dom ready
      
    $.fn.socialScroll = function(ext) {
        
        var scrollBar = '<div class="scrollbar"><div class="track"><div class="thumb"><div class="end"></div></div></div></div>';
        
        return this.each(function() {
            var $scroll = $(this);
            var $content = $scroll.children();
            $content.wrapAll("<div class='viewport' />").wrapAll("<div class='overview' />");
            $(scrollBar).insertBefore($scroll.children());
            $scroll.tinyscrollbar();
        });
    };

    // string replace
    function lnkRplc(raw) {
        var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
        return raw.replace(exp,"<a class='link' href='$1' target='_blank'>$1</a>");
    }
    function usrRplc(raw) {
        var exp = /@([A-Za-z0-9_]+)/ig;
        return raw.replace(exp,"<a class='twitter-user' href='https://twitter.com/@$1' target='_blank'>@$1</a>");
    }
    
    $.fn.initSlider = function (sliderOptions, override, animateOptions, ie) {        
        var slider = $('.slider', this).bxSlider(sliderOptions),
            sliderThumbsWrap = $('.slider-thumbs', this),
            sliderThumbs = $('li', sliderThumbsWrap);
            
        sliderThumbs.first().addClass('active');

        if(ie) {
            sliderThumbsWrap.css('zoom','1');
        };

        sliderThumbs.click(function () {
            switch (override) {
                default:
                    slider.goToSlide($(this).index());
                    sliderThumbs.removeClass('active');
                    $(this).addClass('active');
                    break;
                case 'sliderTools':
                    slider.goToSlide($(this).index());
                    sliderThumbs.animate({ width: animateOptions['start'] }, 0).removeClass('active');
                    $(this).animate({ width: animateOptions['finish'] }, animateOptions['duration']).addClass('active');
                    break;
                case 'sL6sliderTools':
                    slider.goToSlide($(this).index());
                    sliderThumbs.animate({ width: animateOptions['start'] }, 0).removeClass('active');
                    $(this).animate({ width: animateOptions['finish'] }, animateOptions['duration']).addClass('active');
                    break;
            }
            return false;
        });
    };

    function waterMarking(input) {
        //watermarking based on title text
        var wm = input.attr('title');
        if (wm) {
            if (input.val() == "") {
                input.val(wm).addClass('watermark');
            }
            
            input.focus(function () {
                if (input.val() == wm) {
                    input.val("").removeClass('watermark');
                }
            });
            input.blur(function () {
                if (input.val() == "") {
                    input.val(wm).addClass('watermark');
                }
            });
        }
    };

    function checkInterval(slider, options) {
        var interval = $('.slider-interval', slider);
        if (interval.length > 0 && interval.val() != "") {
            options['auto'] = true;
            options['pause'] = interval.val();
            options['autoHover'] = true;
            return options;
        }
        return false;
    };

    $.fn.evenNavigation = function (manualWidth) {
        var navItems = $('li', this).length, //get number of nav items
            navWidth = 0, //initialise
            navContainerWidth = $('#nav').innerWidth();

        var last = $('li:last-child', this);
        last.addClass('last');
        
        if (typeof manualWidth !== 'undefined') {
            navContainerWidth = manualWidth;
        }

        $('li', this).each(function () {
            navWidth += Math.round($(this).outerWidth(true)); //get nav items total width;
        });
        var d = navContainerWidth - navWidth, // get difference in space
            p = Math.floor((d / navItems) / 2); //get padding (remaining space per item) and half form horizontal padding;

        ////apply padding to nav items
        //$('li', this).each(function () {
        //    $('a', this).css({
        //        'padding-left': p,
        //        'padding-right': p
        //    });
        //});

        navWidth = 0;
        $('li', this).each(function () {
            $(this).width($(this).width());
            navWidth += Math.round($(this).outerWidth(true)); //get nav items total width;
            $(this).children('a').css({
                'padding-right': '0',
                'padding-left': '0'
            });
        });

        d = navContainerWidth - navWidth;
        
        if (d > 0) {
            last.width(last.outerWidth(true) + d-2);
        }
        
    };

    $.fn.evenSpacer = function () {
        var item = this,
            itemCount = this.length,
            itemsWidth = 0,
            itemWrapWidth = $(item).parent().innerWidth(),
            itemWrapSpace = 0,
            itemSpacer = 0;

        item.each(function () {
            itemsWidth += $(this).width();
        });
        
        itemWrapSpace = Math.floor(itemWrapWidth - itemsWidth);
        itemSpacer = Math.floor(itemWrapSpace / (itemCount - 1));
        
        item.each(function (i) {
            if (i < itemCount - 1) {
                $(this).css('margin-right', itemSpacer);
            }
            else {
                $(this).css('margin-right', 0);
            }
        });
    };

    function getGeoCode(address, geocodeContainer) {
        var geocoder = new google.maps.Geocoder();
        if (geocoder) {

            blockGeoSearch = true;

            geocoder.geocode({ 'address': address, 'region':'uk' }, function (results, status) {
                blockGeoSearch = false;
                if (status == google.maps.GeocoderStatus.OK) {
                    geoCodeSuccess = true;
                    $('#geocode-validation').hide();

                    geocodeContainer.val(results[0].geometry.location);
                    $('.geo-search-button').each(function() {
                        var button = $(this);
                        if (button.hasClass('clicked')) {
                            button.click();
                        }
                    });
                    
                }
                else {
                    $('#geocode-validation').show();
                    geoCodeSuccess = false;
                }
             });
        }
        else {
            //alert('Error: No Gmaps Geocoder!');
            $('#geocode-validation').show();
            geoCodeSuccess = false;
        }
    };

})(jQuery);

function pageLoad() {
    $('.ajax-toggle-panel .toggle-panel dd').hide();
    $('.ajax-toggle-panel .toggle-panel dt').click(function () {
        $(this).toggleClass('close').next('dd').toggle();
    });
}

/* async load script 
 * v.1.2
 * ---------------------------------------------------------- */
function loadScript(scriptSrc, callback, global) {
    var script = document.createElement('script'),
        path = global === true ? "/js/global/path/libs/" : "/Scripts/libs/";
    script.type = "text/javascript";
    script.src = path + scriptSrc; 
    document.body.appendChild(script);
    if (script.addEventListener && !isIE10) { 
        if (callback) {
            script.addEventListener('load', function (e) { callback(); }, false); 
        }
    } else if (script.attachEvent) { 
        if (callback) {
            script.attachEvent('onreadystatechange', function () {
                script.onload = script.onreadystatechange = null;
                handleIeBug(script, callback);
            }); 
        }
    }
    function handleIeBug(script, callback) {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
            callback();
        }
    }
}

// banner load external bindings
function externalSlideCallback($banner) {
    if ($banner.parent().hasClass("carousel-type-1")) {
        carouselTypeOne.slideCallback($banner);
    }
}

function externalBannerReady($banner) {
    if ($('.carousel-type-1').length) {
        carouselTypeOne.bannerReady($banner);
    }
}

var carouselTypeOne = {

    isOldie: $('html').hasClass('oldie'),
    bannerReady: function ($banner) {
        var $bottomLinks = $banner.find(".pagination-controls .bottom-control"),
            linkNumber = $bottomLinks.length,
            $linkArea = $bottomLinks.find('.link-area'),
            bottomWidth = $banner.width() / linkNumber;

        $bottomLinks.add($bottomLinks.find('.description')).width(bottomWidth); // set widths based on number of items
        if ($('html').hasClass('oldie')) { // oldie alteration to account for decimals in widths
            if (linkNumber == '4' || linkNumber == '3') {
                var $lastBottomLink = $banner.find(".pagination-controls .bottom-control:last"),
                    addWidth = (linkNumber == '4') ? 2 : (linkNumber == '3') ? 1 : 0,
                    newWidth = parseInt($lastBottomLink.css('width')) + addWidth;
                $lastBottomLink.add($bottomLinks.find('.description:last')).width(newWidth);
            }
        }

        $bottomLinks.mouseenter(function () { // force carousel to move on mouseenter of bottom navigation
            $('.slide-container').finish();
            if (!$(this).hasClass('active')) {
                $(this).click();
            }
        });

        $linkArea.click(function () {
            var $link = $(this);
            if ($link.parents('.carousel-type-1').find('.slide-container').find('article').eq($link.parent().index() + $bottomLinks.length).hasClass('visible') && !$link.hasClass('active')) {
                $banner.addClass('greyscale');
                if (carouselTypeOne.isOldie) {
                    $link.addClass('active').next('.description').show(); // show description area on click
                } else {
                    $link.addClass('active').next('.description').slideDown(300);
                }
            }
        });
    },

    slideCallback: function ($banner) {
        var $bottomLinks = $banner.find(".pagination-controls .bottom-control"),
            $linkArea = $bottomLinks.find('.link-area');

        $linkArea.removeClass('active');
        if (carouselTypeOne.isOldie) {
            $banner.removeClass('greyscale').find('.description').hide();
        } else {
            $banner.removeClass('greyscale').find('.description').slideUp();
        }
    }
};

// courses and qualifcations - accordion and tab toggle
function cQAccordion() {
    var accordion = {
        hashFrags: [],
        type: 'full', // the type of hash detection to do
        hashesFired: 0,
        preventHash: false,
        init: function () {
            $(window).on('hashchange', function () {
                if (!accordion.preventHash) {
                    accordion.type = 'full';
                    accordion.determineHash();
                }
            });
  
            accordion.prepContent(); // function to fire only on load
        },
        determineHash: function () {
            accordion.hashFrags = window.location.hash.replace('#', '').split('&'); // determine hash fragments
            var frags = [];
            if (accordion.type === 'full') {
                accordion.hashesFired = 1;
                frags = accordion.hashFrags[0].split('=');
            } else if (accordion.type === 'partial') { // partial is only used if full has already fired
                accordion.hashesFired++;
                frags = accordion.hashFrags[accordion.hashFrags.length - 1].split('=');
            }
            var elemType = frags[0],
                frag = frags[1],
                $trigger = { // determine corresponding trigger based on fragment
                    'fil': $('.location-filter li.region[data-filter="' + frag + '"]'),
                    'tab': $('.tabbed-nav li a[data-tabtype="' + frag + '"]'),
                    'acc': $('#tabbed-content-container').length ?
                        $('#tabbed-content-container').children('.active').find('.accordion-toggle[data-urltag="' + frag + '"]') :
                        $('.location-contents').children('.current').find('.accordion-toggle[data-urltag="' + frag + '"]')
                }[elemType];
            accordion.clickEvent($trigger, elemType);
        },
        updateHash: function (newHash, elemType) {
            var elemTypeShort = elemType.substr(0, 3),
                hashUpdate = elemTypeShort + '=' + newHash;
            if (elemType !== 'acc') {
                window.location.hash = hashUpdate; // replace url string from hash if clicking on tab or filter
            } else { // if clicking on accordion-toggle
                if (window.location.hash.indexOf('&') > -1) { // if an acc param is currently present, replace it
                    window.location.hash = window.location.hash.split('&')[0] + '&' + hashUpdate;
                } else { // if no acc param present, add it
                    window.location.hash += '&' + hashUpdate;
                }
            }
        },
        prepContent: function () { // on load
            //var $tabbedNavExists = $('.tabbed-nav').length, // check if tabs are on the page
            //    $filterPage = $('.location-filter').length, // check if filters are on the page
            //    $elemForEvents = $filterPage ? $('.location-filter li') :
            //        $tabbedNavExists ? $('.tabbed-nav').find('a') : $('.accordion-toggle');

            var $elemForEvents = $('.location-filter li, .tabbed-nav a, .accordion-header, .accordion-content .read-more');
            
            accordion.bindEvents($elemForEvents); // bind click events on load based on page type

            if (!window.location.hash) { // if no hash, fire determineClick
                accordion.determineClick($elemForEvents.filter(':first'));
            } else { // if hash, fire determine hash, which will then fire determineClick
                accordion.determineHash();
            }
        },
        bindEvents: function ($eventTrigger) { // bind click events 
           
            $eventTrigger.click(function () {
                accordion.determineClick($(this));
            });
        },
        returnType: function($navTrigger) { // returns element type - either filter, accordion, or tab
            return $navTrigger.hasClass('region') ? 'fil' : $navTrigger.is('.accordion-toggle, .read-more') ? 'acc' : 'tab';
        },
        determineClick: function ($navTrigger) {
            if ($navTrigger.hasClass('accordion-header')) {
                $navTrigger = $navTrigger.find('.accordion-toggle');
            }
            var elemType = accordion.returnType($navTrigger),
                toUpdateHash = {
                    'acc': $navTrigger.data('urltag'),
                    'fil': $navTrigger.data('filter'),
                    'tab': $navTrigger.data('tabtype')
                }[elemType];

            if (!$navTrigger.hasClass('disabled')) { // don't continue if the trigger is disabled (primarily for accordion links)
                if (!$('html').hasClass('ie7')) { // do hashchange work if not ie7
                    if ($navTrigger.parent().hasClass('expanded')) { // if clicking an expanded accordion, remove accordion info from hash
                        // prevent hashchange event firing in this case to preserve browser history (as determineClick is not fired in hashchange event)
                        accordion.preventHash = true;
                        window.location.hash = window.location.hash.split('&acc')[0];
                    } else {
                        if (toUpdateHash && window.location.hash.indexOf(toUpdateHash) === -1) {
                            accordion.updateHash(toUpdateHash, elemType);
                            return false; // return false if updating hash, as click event is fired at the end of the hashchange event
                        }
                    }
                }
                accordion.clickEvent($navTrigger, elemType);
            }
        },
        clickEvent: function ($navTrigger, elemType) {
            if ($navTrigger.hasClass('disabled')) { // check also done here to cater for invalid hash in the url
                return false;
            }
            accordion.preventHash = false;
            var dataAttr = {
                    'fil': $navTrigger.data('filter'),
                    'tab': $navTrigger.data('tabtype'),
                    'acc': $navTrigger.data('urltag')
                },
                $elemToFill = {
                    'fil': $navTrigger.parents('.location-filter').next('.location-contents').children('.' + dataAttr[elemType] + ''),
                    'tab': $('#tabbed-content-container').children('.tabbed-content[data-contenttype="' + dataAttr[elemType] + '"]'),
                    'acc': $navTrigger.hasClass('accordion-toggle') ? $navTrigger.parent().next(".accordion-content") : $navTrigger.prev('ul')
                }[elemType];
     
            if ($elemToFill.length > 0) { // if there is a corresponding element to be filled
                if (!$elemToFill.html().length) { // only make ajax call if the elem to fill hasn't been populated already
                    accordion.fetchData($navTrigger, elemType, $elemToFill);
                } else { // run toggle content if $elemToFill has content already
                    accordion.toggleContent($navTrigger, elemType, $elemToFill);
                }
            }
        },
        fetchData: function ($trigger, elemType, $elemToFill) { // ajax call - only fires if $elemToFill has no inner html
            var url = { // determine webservice url based on element type
                    'fil': '/WebServices/CourseService.svc/GetFilteredData' + $trigger.parent('ul').data('type'),
                    'tab': '/WebServices/CourseService.svc/GetTab' + $trigger.data('tabtype'),
                    'acc': '/WebServices/CourseService.svc/Get' + $trigger.data('accordiontype')
            }[elemType];
            if (elemType === 'fil') {
                $elemToFill.parent().children('.loading').fadeIn();
            }
    
            $.ajax({
                url: url,
                data: {
                    guid: $trigger.data('guid').replace('{', '').replace('}', ''),
                    filter: $trigger.data('filter') || '',
                    index: $trigger.data('index') || 0
                },
                type: "GET",
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                success: function (data) {
                    if (elemType === 'fil') {
                        $elemToFill.parent().children('.loading').fadeOut();
                    }
                    accordion.fetchDataSuccess($trigger, data, elemType, $elemToFill);
                    
                    accordion.toggleLoadingIndicator(false);
                }
            });
        },
        toggleLoadingIndicator: function(enable) {
            if (enable) {
                $(".loading-indicator").show();
            } else {
                $(".loading-indicator").hide();
            }
        },
        fetchDataSuccess: function ($trigger, data, elemType, $elemToFill) {
            if ($elemToFill.is('ul')) { // is only ul if clicking see more inside accordions
                $elemToFill.append($(data.d.Html).html()); // append content in this case
                $elemToFill.next('.read-more').data('index', data.d.NextIndex); // update index on read more link for next webservice call
            } else { // normal case
                $elemToFill.html(data.d.Html || data.d); // fill the relevant div
                accordion.toggleContent($trigger, elemType, $elemToFill); // function to show/hide relevant areas
                accordion.bindEvents($elemToFill.find('.accordion-header')); // bind events to new accordion-toggle spans
            }
            if (elemType === 'acc') {
                if (data.d.Complete) {
                    $elemToFill.parent().addClass('hide-read-more'); // uses this class to hide the read more link
                }
            }
            if ($elemToFill.find('.reviews-container').length) { // if reviews are included in the response, initiate review truncate
                accordion.reviewTruncate($elemToFill.find('.reviews-container')); 
            }
            // update read more link with new index + bind click function - will only run this on first load as the read-more span is outside of the ul
            if ((elemType === 'acc' || elemType === 'fil') && $elemToFill.find('.read-more').length) {
                var $readMore = $elemToFill.find('.read-more');
                if (data.d.NextIndex) {
                    $readMore.data('index', data.d.NextIndex);
                }
                $readMore.click(function () {
                    accordion.fetchData($(this), 'acc', $(this).prev('ul'));
                });
            }
        },
        // function to show/hide relevant content - fires if target div is already filled, or on ajax success
        toggleContent: function ($trigger, elemType, $elemToShow) {
            switch (elemType) {
                case 'fil':
                    $trigger.parent().children().removeClass('current');
                    $trigger.addClass('current');
                    $trigger.parents('.location-filter').next('.location-contents').children().removeClass('current').hide();
                    $elemToShow.addClass('current').show();
                    break;
                case 'tab':
                    // add active class to corresponding tab (based on click, or on load)
                    $trigger.parents('ul').children().children().removeClass('active');
                    $trigger.addClass('active');
                    if (!$elemToShow.hasClass('active')) {
                        $('#tabbed-content-container').children('.tabbed-content').removeClass('active').hide(); // hide tab areas
                    }
                    // show corresponding tab content area
                    $elemToShow.addClass('active').show();
                    break;
                case 'acc':
                    if ($trigger.hasClass('read-more')) { // show additional items when clicking read more link in accordions
                        var $lis = $trigger.prev('ul').children('li'),
                            $visLisNum = $lis.filter('.show').length;
                        $lis.each(function(e) {
                            if (e >= $visLisNum && e < $visLisNum + $trigger.data('index')) {
                                $(this).addClass('show');
                            }
                        });
                        if ($lis.length === $lis.filter('.show').length) {
                            $trigger.parent().addClass('hide-read-more');
                        }
                    } else {
                        var $accordionHeader = $trigger.parent();

                        if ($accordionHeader.hasClass("expanded")) { // if clicking on currently expanded accordion, close it
                            $accordionHeader.removeClass("expanded").parent(".accordion-container").removeClass('active').children(".accordion-content").slideUp("fast");
                        } else {
                            if (!$elemToShow.is(":animated")) { // expand accordion
                                $accordionHeader.addClass("expanded").parent(".accordion-container").addClass('active').children(".accordion-content").slideDown("fast");
                            }
                        }
                    }
                    break;
            }
            // if only 1 hash event has fired, and there is more than 1 hash param, fire second determine hash
            if (accordion.hashFrags.length > 1 && accordion.hashesFired < accordion.hashFrags.length) { 
                accordion.type = 'partial';
                accordion.determineHash();
            }
        },
        reviewTruncate: function ($currentReview) { // truncate reviews if longer than 200 words
            $currentReview.children('ul').children('li').each(function (e) {
                var $review = $(this),
                    $readMore = $review.find('span.read-more'),
                    $readLess = $review.find('span.read-less');
                $readMore.add($readLess).remove(); // have to remove them here so innerText variable doesn't include them
                var $reviewText = $review.find('p'),
                    innerText = $reviewText.text();
                if (innerText.split(' ').length > 200) {
                    // the split and splice string needs to be done each time instead of stored previously, otherwise it isn't calculated properly
                    var firstTextsection = '<span class="first-section">' + innerText.split(' ').splice(0, 200).join(' ') + '</span>',
                        lastTextsection = '<span class="last-section">' + innerText.split(' ').splice(200, innerText.split(' ').length).join(' ') + ' </span>';
                    $reviewText.html(firstTextsection + ' ' + lastTextsection).append($readMore, $readLess);
                }
            });
            // bind click functions for read-more and read-less links
            $currentReview.find('.read-more').click(function () {
                $(this).parent().find('.read-more').fadeOut(100, function () {
                    $(this).parent().addClass('expanded').find('.last-section, .read-less').fadeIn(100);
                });
            });
            $currentReview.find('.read-less').on('click', function () {
                if ($(this).parent().hasClass('expanded')) {
                    $(this).parent().removeClass('expanded').find('.last-section, .read-less').fadeOut(100, function () {
                        $(this).parent().find('.read-more').fadeIn(100);
                    });
                }
            });
        }
    };
    accordion.init();
}

//Evenly space navigation items
//$('#main-nav').evenNavigation();

/* evenly space footer logos */
$('#site-logos li').evenSpacer();